export const MUTATION_TYPES = {
  //General Filters
  ADD_STUDENT_SEARCHED: 'AddStudentSearched',
  SET_ALERTS: 'setSelectedStudentAlerts',
  TOGGLE_SEARCH: 'toggleSearchMenu',
  SHOW_SELECTED_STUDENT: 'showStudentBox',
  SET_NAVIGATION_VIEW_DISPLAY: 'setNavigationToViewDisplay',
  SELECTED_STUDENT: 'setSelectedStudent',
  SELECTED_STUDENT_DETAILS: 'setSelectedStudentDetailst',
  CLEAR_ALERTS: 'setClearStudentAlerts',
  CLEAR_STUDENT: 'clearSelectedStudent',
  SET_SHOW_STUDENT_SELECTED: 'setShowStudentSelected',
  TOGGLE_FAST_SEARCH: 'toogleFastSearch',
  SET_STUDENT_PRE_REGISTRY_VALIDATIONS: 'setStudentPreRegistryValidations',
  SET_STUDENT_PRE_REGISTRY: 'setStudentPreRegistry',
  SET_REGISTER_SAVE_PROPAGATION: 'setRegisterSavePropagation',
};
//actions Think is need to do this? (Only if is calling )
export const ACTION_TYPES = {
  GET_USER_STUDENT_SEARCHED_HISTORY: 'getUserStudentSearchedHistory',
  SET_STUDENT_DETAILS: 'setStudentDetails',
  REFRESH_STUDENT_MAIN_INFO: 'refreshStudentMainInfo',
};
